/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid, Box, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { makeStyles } from '@mui/styles';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import DialogModal from '../../../components/modal/DialogModal';
import adminServices from '../../../services/adminServices';
import SnackBar from '../../../components/snackbar/snackbar';

const CloningAssessment = ({ title, open, modelClose,CallBack }) => {
    const navigate = useNavigate();
    const userId = useSelector((state) => state.userInfo.id && state.userInfo.id);
    const [loadingbtn, setLoadingbtn] = useState(false);
    const [category, setCategory] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [ownerID, setOwnerID] = useState([]);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarTitle, setSnackbarTitle] = React.useState('');
    const [authors, setAuthors] = useState([]);
    const [satDetails, setSatDetails] = useState([]);
   console.log(satDetails,"satDetails");
   

    // eslint-disable-next-line no-unused-vars
    const [initialValues, setInitialValues] = useState({
        courseCategory: null,
        copiedCourseName: '',
        courseContenter: null,
        authors: []
    });

    // eslint-disable-next-line no-unused-vars
    const classes = useStyles();

    const postCloningAssessments = async (id,values) => {
        const formData = new FormData();
        formData.append('name', values?.copiedCourseName);
        formData.append('complexity_level', values?.courseCategory?.complexity_level);
        formData.append('description', values?.courseCategory?.short_description);
        formData.append('time_in_mins', 7920);
        formData.append('thumbImage', values?.courseCategory?.image_name);
        formData.append('modules', JSON.stringify(values?.courseCategory?.modules));
        formData.append('is_published', false);
        formData.append('userId', userId);
        formData.append('selectedQuestions', values?.courseCategory?.questions_list);
        formData.append('is_free', false);
        formData.append('hasCertificate', false);
        formData.append("short_description", values?.courseCategory?.short_description);
        formData.append("assessment_type_id", values?.courseCategory?.assessment_sub_type_id);
        formData.append("sub_assessment_id", id);
        try {
            const res = await adminServices.SatCreation(formData);
            if (res.ok) {
                CallBack()
                setOpenSnackbar(true);
                setSnackbarTitle("Sat Cloned Successfully");
                setLoadingbtn(false);
               
                await navigate('/app/satpage');
                modelClose();
            } else if (!res.ok) {
                setOpenSnackbar(true);
                setSnackbarTitle(res.data.message);
                setLoadingbtn(false);
            }
        } catch (error) {
            console.log(error);
            setLoadingbtn(false);
            modelClose();
        }
    };

    useEffect(async () => {
        getSATDetails();
        await getAuthors()
    }, []);

    const getAuthors = async (code) => {
        try {
            const response = await adminServices.getAuthors();
            if (response.ok) {
                const authArray = []
                console.log(response.data);
                (response.data).forEach(a => { authArray.push(a.name) })
                setAuthors(authArray);

                return true;
            }
        } catch (error) {
            console.log(error);
        }
    }


    const getSATDetails = async () => {
        const result = await adminServices.getSATAssessmentAdmin('', 0, 200,);
        if (result.ok) {
            const satDetails = result.data.assessments?.map(item => ({
                id: item.assessment.id,
                title: item.assessment.title,
                authorName: item.assessment.author_first_name,
                complexityLevel: item.assessment.complexity_level,
                isPublished: item.assessment.is_published,
                statusType: item.assessment.status_type,
                ...item.assessment
            }));
            setSatDetails(satDetails)
        }

    }

    return (
        <>
            <DialogModal open={open} handleClose={modelClose} title={title}>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={Yup.object().shape({
                        courseCategory: Yup.string().required('Required').nullable(),
                        copiedCourseName: Yup.string().required('Required').nullable(),
                        courseContenter: Yup.string().nullable(),
                    })}
                    onSubmit={(values) => {                        
                        postCloningAssessments(values.courseCategory.id, values);
                        setLoadingbtn(true);
                    }}
                >
                    {({ values, touched, errors, handleBlur, handleChange, setFieldValue }) => (
                        <Form>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        id="country-select-demo"
                                        fullWidth
                                        filterSelectedOptions
                                        options={satDetails}
                                        autoHighlight
                                        getOptionLabel={(option) => option?.title || ''}
                                        getOptionDisabled={(option) => Boolean(option?.sub_id)} 
                                        value={values.courseCategory || null}
                                        onChange={(e, value) => {
                                            if (value != null) {
                                                setFieldValue('courseCategory', value);
                                                setFieldValue('copiedCourseName', `${value.title} Copied`);
                                            } else {
                                                setFieldValue('courseCategory', null);
                                                setFieldValue('copiedCourseName', '');
                                            }
                                        }}
                                        renderOption={(props, option) => {
                                            
                                            const { key, ...otherProps } = props;
                                            return (
                                                <Box
                                                    key={option.id}
                                                    component="li"
                                                    {...otherProps}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-start',
                                                        alignItems: 'flex-start',
                                                        flexDirection: 'column',
                                                        padding: '8px 16px',
                                                        opacity: option?.sub_id ? 0.5 : 1, 
                                                        pointerEvents: option?.sub_id ? 'none' : 'auto'
                                                    }}
                                                >
                                                    <Typography variant="body1" width="100%">
                                                        {option.title}
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        width="100%"
                                                        sx={{
                                                            fontSize: '12px',
                                                            color: 'text.secondary'
                                                        }}
                                                    >
                                                        Author: {option.authorName}
                                                    </Typography>
                                                </Box>
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="courseCategory"
                                                error={Boolean(touched.courseCategory && errors.courseCategory)}
                                                helperText={touched.courseCategory && errors.courseCategory}
                                                label="Select Assessments which you want to clone*"
                                                inputProps={{
                                                    ...params.inputProps,
                                                }}
                                            />
                                        )}
                                    />

                                    <Box mt={2} mb={2}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            value={values.copiedCourseName}
                                            name="copiedCourseName"
                                            label="Cloning Assessments name*"
                                            onBlur={handleBlur}
                                            // onChange={handleChange}
                                            onChange={(e, value) => {
                                                setFieldValue('copiedCourseName', e.target.value);
                                            }}
                                            variant="outlined"
                                            error={Boolean(touched.copiedCourseName && errors.copiedCourseName)}
                                            helperText={touched.copiedCourseName && errors.copiedCourseName}
                                        />
                                    </Box>
                                    <Autocomplete
                                        options={authors}
                                        // filterSelectedOptions
                                        autoHighlight
                                        multiple
                                        getOptionLabel={(option) => option.name || option || ''}
                                        value={values.authors}
                                        name="authors"
                                        onChange={(e, value) => {
                                            setFieldValue('authors', value)
                                        }}
                                        onBlur={handleBlur}
                                        renderOption={(props, option) => (
                                            <>
                                                <Box
                                                    {...props}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'start',
                                                        alignItems: 'start',
                                                        flexDirection: 'column',
                                                    }}
                                                >
                                                    <Typography variant="body1" width="100%">
                                                        {option}
                                                    </Typography>

                                                </Box>
                                            </>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Select author *"
                                                variant="outlined"
                                                fullWidth
                                                error={Boolean(touched.authors && errors.authors)}
                                                helperText={touched.authors && errors.authors}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item sm={12}>
                                    <LoadingButton id='submitButtonId' type="submit" variant="contained" color="primary" fullWidth loading={loadingbtn}>
                                        Submit
                                    </LoadingButton>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogModal>
            <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
        </>
    );
};

const useStyles = makeStyles(() => ({
    imgPreviewRoot: {
        borderRadius: '10px',
        padding: '0.8rem;',
    },
    fileImgSIze: {
        width: '100%',
        height: '120px',
        objectFit: 'cover',
        objectPosition: 'center',
        border: '1px solid #fff',
        borderRadius: '5px',
        boxShadow: '0 3px 10px rgb(0 0 0 / 20%)',
    },
    badgeAlign: {
        boxShadow: '0 2px 8px -5px #ff0000',
        color: '#FF0000',
        fontSize: '1.2rem',
        backgroundColor: '#fff',
        padding: '2px',
        borderRadius: '10px',
        cursor: 'pointer',
    },
    deleteLabel: {
        width: 'max-content',
        cursor: 'pointer',
    },
}));

export default CloningAssessment;